import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {categories.map((c) => (
        <a
          key={c.id}
          href={c.url}
          target="_blank"
          rel="noopener nofollow"
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
        >
          <div className="aspect-square w-full overflow-hidden bg-background-100">
            <img
              src={c.image}
              alt={t(`cat.${c.id}`)}
              title={`${t("site.name")} ${t(`cat.${c.id}`)}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex items-center justify-between gap-2 px-4 py-3">
            <span className="whitespace-nowrap text-sm font-semibold text-foreground-900">{t(`cat.${c.id}`)}</span>
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}